import React, { useEffect, useState } from "react";
import DynamicFormModal from "../../utils/NewFormStructure/DynamicFormModal";
import * as Action from "../../../actions/Setting/promotion";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { FileVideoCamera } from "lucide-react";

const PromotionVideo = () => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form, setForm] = useState({});
  const [isEdit, setIsEdit] = useState(true);
  const { promotion_video_list, promotion_video_update } = bindActionCreators(
    Action,
    dispatch,
  );
  useEffect(() => {
    const languageData = async () => {
      try {
        const resData = await promotion_video_list();
        console.log(resData, "sdffsdfsd");
        if (resData?.data) {
          setForm(resData?.data);
        }
      } catch (ele) {
        console.error(ele);
      } finally {
      }
    };
    languageData();
  }, []);

  const FormStructure = [
    {
      type: "inputBox",
      name: "promotion_video",
      title: "Promotion Video URL",
      placeholder: "Enter Promotion Video url",
      required: true,
    },
  ].filter((e) => e);

  const handleSubmit1 = async (event) => {
    const resData = await promotion_video_update(form);
    console.log(resData, "neweweweweweew");
    if (resData?.message) {
      setIsModalOpen(false);
      // navigate("/masters/category/", { state: { formUpload: true } });
    } else {
      setForm(form);
      // setIsModalOpen(true)
    }
  };

  return (
    <div>
      {" "}
      <DynamicFormModal
        open={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setForm({});
          setIsEdit(false);
        }}
        formStructure={FormStructure}
        onSubmit={handleSubmit1}
        formData={form}
        setFormData={setForm}
        title={isEdit ? "Edit Promotion" : "Add Promotion"}
        initialData={{}}
      />
         <FileVideoCamera onClick={()=>setIsModalOpen(true)} />
    </div>
  );
};

export default PromotionVideo;
